export const DROPDOWN_ID = "traffic-threshold";

export const DROPDOWN_HEIGHT = 160;

export const DROPDOWN_WIDTH = 160;
